"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.cEventContextSchema = void 0;
var zod_1 = require("zod");
var hooks_1 = require("../hooks");
var index_1 = require("./index");
/**
* WHEN CREATING A NEW HOOK:
* I.   VALIDATE your type using `cMyEvent = z.strictObject({...})`
* II.  DECLARE your type as `type MyEvent = z.infer<typeof MyEvent>`
* III. REGISTER your type in `cEventContextSchema` as:
* 			[HookName.myEvent]: cMyEventSchema
*/
exports.cEventContextSchema = (_a = {},
    _a[hooks_1.HookName.onLogin] = zod_1.z.never(),
    // global
    _a[hooks_1.HookName.broadcastNotificationToList] = index_1.broadcastNotificationToList.Schema,
    // admin
    _a[hooks_1.HookName.abuseReported] = index_1.abuseReported.Schema,
    _a[hooks_1.HookName.newApplication] = index_1.newApplication.Schema,
    _a[hooks_1.HookName.newUserCreatedEntity] = index_1.newUserCreatedEntity.Schema,
    // entities
    _a[hooks_1.HookName.entityCreated] = index_1.entityCreated.Schema,
    _a[hooks_1.HookName.entityUpdated] = index_1.entityUpdated.Schema,
    _a[hooks_1.HookName.entityDeleted] = index_1.entityDeleted.Schema,
    // memberships
    _a[hooks_1.HookName.appliedOnMembership] = index_1.membershipStateChange.Schema,
    _a[hooks_1.HookName.acceptedOnMembership] = index_1.membershipStateChange.Schema,
    _a[hooks_1.HookName.rejectedOnMembership] = index_1.membershipStateChange.Schema,
    _a[hooks_1.HookName.completedOnMembership] = index_1.membershipStateChange.Schema,
    _a[hooks_1.HookName.returnedOnMembership] = index_1.membershipStateChange.Schema,
    _a[hooks_1.HookName.withdrawnOnMembership] = index_1.membershipStateChange.Schema,
    _a[hooks_1.HookName.bannedOnMembership] = index_1.membershipStateChange.Schema,
    // connections
    _a[hooks_1.HookName.newConnectionRequest] = index_1.newConnectionRequest.Schema,
    _a[hooks_1.HookName.connectionRequestArranged] = index_1.connectionRequestArranged.Schema,
    _a[hooks_1.HookName.connectionRequestAccepted] = index_1.connectionRequestAccepted.Schema,
    _a[hooks_1.HookName.connectionRequestRejected] = index_1.connectionRequestRejected.Schema,
    _a[hooks_1.HookName.connectionRequestCompleted] = index_1.connectionRequestCompleted.Schema,
    // chats
    _a[hooks_1.HookName.newMessage] = index_1.newMessage.Schema,
    // discussions
    _a[hooks_1.HookName.mention] = index_1.mention.Schema,
    _a[hooks_1.HookName.newDiscussion] = index_1.newDiscussion.Schema,
    _a[hooks_1.HookName.newCommentReply] = index_1.newCommentReply.Schema,
    _a);
